import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { BrokeFlexMessageService } from '../services'
import {
	CreateBrokeFlexMessageCampaignRequest,
	BrokeFlexMessageCampaignResponse,
} from '../../types'

function useMutationCreateBrokeFlexMessageCampaign(
	options?: UseMutationOptions<
		BrokeFlexMessageCampaignResponse,
		Error,
		CreateBrokeFlexMessageCampaignRequest
	>,
) {
	return useMutation({
		mutationFn: (data: CreateBrokeFlexMessageCampaignRequest) =>
			BrokeFlexMessageService.createCampaign(data),
		...options,
	})
}

export default useMutationCreateBrokeFlexMessageCampaign
